import { render, staticRenderFns } from "./Followtestdetail-child1.vue?vue&type=template&id=b06d33ae&scoped=true"
import script from "./Followtestdetail-child1.vue?vue&type=script&lang=js"
export * from "./Followtestdetail-child1.vue?vue&type=script&lang=js"
import style0 from "./Followtestdetail-child1.vue?vue&type=style&index=0&id=b06d33ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b06d33ae",
  null
  
)

export default component.exports